import React from 'react'
import useLocalStorageData from 'src/hooks/useLocalStorageData'
const PageNotFound = () => {
    const { AuthToken } = useLocalStorageData()

    const handleToLogin = () => {
        window.location.pathname = "/"
    }
    return (
        <>
            {AuthToken ? (
                < div className='flex justify-center items-center h-screen' >
                    404  Page Not Found
                </div >
            ) : handleToLogin()}
        </>
    )
}

export default PageNotFound